import { DEFAULT_FIELD_SETTINGS } from '@databases/collab/utils';
import { type YDatabase } from '@databases/collab/y-database';
import { getFieldTypeName } from '@databases/intl/field-type-names';
import { messages } from '@databases/intl/messages';
import { FieldType } from '@databases/model/field';
import { DatabaseFieldType } from '@databases/types/database';
import type { IntlShape } from 'react-intl-next';
import { v5 as uuidv5 } from 'uuid';

const DEFAULT_NAMESPACE = '319e34ab-a1c3-45c8-b7b9-6758bb7b7c1d';
const DEFAULT_ENTRY_COUNT = 5;
/**
 * Adds a default document to the database.
 */
export const initialDoc = {
  version: 1,
  apply(documentId: string, ydb: YDatabase, intl: IntlShape) {
    const documentNamespace = uuidv5(documentId, DEFAULT_NAMESPACE);
    const { formatMessage } = intl;

    ydb.mutate(() => {
      if (ydb.fields.length === 0) {
        const fieldId = uuidv5('field-1', documentNamespace);
        ydb.addFieldFromJSON(fieldId, {
          name: formatMessage(
            messages['field-settings.field-name-inline-edit-default-text'],
            {
              defaultFieldName: formatMessage(getFieldTypeName(DatabaseFieldType.TEXT))
            }
          ),
          type: FieldType.Text,
          width: undefined,
          description: '',
          ...DEFAULT_FIELD_SETTINGS
        });

        ydb.addFieldFromJSON(uuidv5('field-2', documentNamespace), {
          name: formatMessage(
            messages['field-settings.field-name-inline-edit-default-text'],
            {
              defaultFieldName: formatMessage(getFieldTypeName(DatabaseFieldType.SELECT))
            }
          ),
          type: FieldType.Select,
          width: undefined,
          description: '',
          ...DEFAULT_FIELD_SETTINGS
        });

        ydb.addFieldFromJSON(uuidv5('field-3', documentNamespace), {
          name: formatMessage(
            messages['field-settings.field-name-inline-edit-default-text'],
            {
              defaultFieldName: formatMessage(getFieldTypeName(DatabaseFieldType.USER))
            }
          ),
          type: FieldType.User,
          width: undefined,
          description: '',
          ...DEFAULT_FIELD_SETTINGS
        });
      }

      if (ydb.entries.length === 0) {
        for (let i = 0; i < DEFAULT_ENTRY_COUNT; i++) {
          ydb.addEntry(uuidv5(`entry-${i}`, documentNamespace));
        }
      }
    });
  }
};
